import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    root: {
        borderRadius: '8px',
        boxShadow: 'rgb(3 0 71 / 9%) 0px 1px 3px',
        padding: '2px'
    },
    media: {
        height: 0,
        paddingTop: '56.25%',
        backgroundSize: 'contain',
        marginBottom: '30px',
        width: '50%',
        margin: 'auto'
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    cardContent: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    cardIcon: {
        width: '50px',
        height: '50px',
        color: '#2a4361',
        background: '#f5f5f5',
        "&:hover": {
            // boxShadow: "1px 1px 1px 1px rgba(15, 52, 96)"
            border: '1px  solid rgba(15, 52, 96, .2)'
        }
    },

    name: {
        color: 'rgb(55, 63, 80)',
        fontSize: '15px'
    },

    price: {
        color: 'rgb(210, 63, 87)',
        fontWeight: '600',
        fontSize: '15px'
    },

    description: {
        color: '#4d525c'
    }
}))

